<template>

  <div class="link-break-content" style="margin-top: 60px;">
      
                <icon-base icon-name="bid" width="40" height="36" viewbox="0 0 40 36">
                    <icon-link-break/>
                </icon-base>
                <h4>{{$t('message.invalidLinkTitle')}}</h4>
                <p class="small-text grey-text-1">{{$t('message.invalidLinktext')}}</p>
        
  </div>

</template>

<script>
import IconBase from '../components/IconBase.vue'
import IconLinkBreak from '../components/icons/IconLinkBreak.vue'

export default {
    components: {
        IconBase,
        IconLinkBreak
    },
}
</script>

<style lang="scss">
    .link-break-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 90px 28px 20px;

        h4 {
            margin-top: 10px;
            font-weight: 500;
            font-size: 20px;
            line-height: 24px;
        }

        p {
            text-align: center;
        }
    }
</style>